import Env from 'Services/Env';
import { getErrorInput, getErrorLabel } from 'api/sellsyaccountmanager';
export default class StripeSellsy {
    constructor() {
        this.cardNumber = null;
        this.cardExpiration = null;
        this.cardCvc = null;
        this.cardId = null;
        this.Elements = null;
        this.publishableKey = Env.get('stripe').publishableKey;
        this.stripe = null;
        this.init();
    }

    async init() {
        await this.initStripeScript();
        this.initStripe();
        this.initInputsWithElements();
    }

    initStripeScript() {
        return new Promise((resolve, reject) => {
            let script = document.createElement('script');
            script.onload = () => {
                resolve()
            };
            script.async = true;
            script.src = 'https://js.stripe.com/v3/';
            document.head.appendChild(script);
        })
    }

    initStripe() {
        this.stripe = window.Stripe(this.publishableKey)
        this.Elements = this.stripe.elements();
    }

    initInputsWithElements() {
        if (!!document.getElementById('stripe-number-card')) this.cardNumber = this.buildElement('cardNumber', '#stripe-number-card');
        if (!!document.getElementById('stripe-expiration-card')) this.cardExpiration = this.buildElement('cardExpiry', '#stripe-expiration-card');
        if (!!document.getElementById('stripe-cvc-card')) this.cardCvc = this.buildElement('cardCvc', '#stripe-cvc-card');
    }

    buildElement(type, selector) {
        const options = {
            classes: {
                base: 'h-32 br b-1 pt-2 px-2',
                invalid: 'b-1-alert-50'
            },
            showIcon: true,
        }
        let cardElement = this.Elements.create(type, options);
        cardElement.mount(selector);

        cardElement.on('change', function (event) {
            if (event.error) {
                window.sellsyapp.$events.trigger('stripe:error', {type, message: event.error.message });
            } else {
                window.sellsyapp.$events.trigger('stripe:clear', { type, event })
            }
        });
        return cardElement;
    };

    createToken(data) {
        return this.stripe.createToken(this.cardNumber, data);
    }

    confirmCardPayment(clientSecret) {
        return new Promise((resolve, reject) => {
            this.stripe.confirmCardPayment(clientSecret, {
                save_payment_method: true,
                payment_method: this.cardId ?? { card: this.cardNumber }
            }).then(response => {
                if(response.error) {
                    reject({
                        code: getErrorInput(response.error.code),
                        message: getErrorLabel(response.error.code)
                    });
                }

                resolve(response);
            });
        });
    }

    setCard(card) {
        this.cardId = card;
    }
}